var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/outline';
import clsx from 'clsx';
import React from 'react';
import { composeHandlers } from '../../utils/composeHandlers';
import { getDefaultValue } from './__internals/constants';
import { DropdownList } from './__internals/DropdownList';
export function Select(_a) {
    var options = _a.options, value = _a.value, _b = _a.disabled, disabled = _b === void 0 ? false : _b, onChange = _a.onChange, placeholder = _a.placeholder, label = _a.label, 
    //TODO: error,
    _c = _a.getOptionLabel, 
    //TODO: error,
    getOptionLabel = _c === void 0 ? getDefaultValue : _c, 
    // Forwarded props.
    style = _a.style, className = _a.className, onBlurProp = _a.onBlur, onFocusProp = _a.onFocus, props = __rest(_a, ["options", "value", "disabled", "onChange", "placeholder", "label", "getOptionLabel", "style", "className", "onBlur", "onFocus"]);
    var nativeInputElement = React.useRef(null);
    var optionListElement = React.useRef(null);
    var wrapperElement = React.useRef(null);
    var arrowElement = React.useRef(null);
    var _d = React.useState(false), focused = _d[0], setFocused = _d[1];
    var _e = React.useState(true), preventOpen = _e[0], setPreventOpen = _e[1];
    var _f = React.useState(''), searchValue = _f[0], setSearchValue = _f[1];
    React.useEffect(function () {
        if (!focused) {
            setPreventOpen(true);
        }
    }, [focused]);
    React.useEffect(function () {
        if (preventOpen) {
            setSearchValue('');
        }
    }, [preventOpen, setSearchValue]);
    React.useEffect(function () {
        if (searchValue !== '') {
            setPreventOpen(false);
        }
    }, [searchValue]);
    function onWrapperClick() {
        if (!disabled) {
            setPreventOpen(function (preventOpen) { return !preventOpen; });
        }
    }
    function onForwardFocus() {
        var _a;
        if (!disabled) {
            (_a = nativeInputElement.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }
    function onNativeInputFocus() {
        if (!focused && !disabled) {
            setFocused(true);
        }
    }
    function onNativeInputBlur(event) {
        var focusedElement = event.relatedTarget;
        if (focusedElement !== wrapperElement.current &&
            focusedElement !== arrowElement.current &&
            (optionListElement.current == null ||
                focusedElement !== optionListElement.current)) {
            setFocused(false);
        }
    }
    var onSelectOption = function (option) {
        setPreventOpen(true);
        onChange(option);
    };
    var nativeInputValue = value ? getOptionLabel(value) : '';
    var opened = focused && !preventOpen;
    var textColor = !!value && !disabled ? 'text-neutral-5' : 'text-neutral-4';
    var ChevronIconComponent = opened ? ChevronUpIcon : ChevronDownIcon;
    var cursor = disabled ? 'cursor-not-allowed' : 'cursor-pointer';
    return (React.createElement(React.Fragment, null,
        React.createElement("div", __assign({ className: clsx('w-full flex flex-col', className) }, props),
            label && (React.createElement("label", { className: "text-neutral-5 mb-2 text-xs" }, label)),
            React.createElement("div", { ref: wrapperElement, onClick: onWrapperClick, onFocus: onForwardFocus, tabIndex: disabled ? undefined : -1, className: clsx(cursor, !disabled ? 'bg-black' : 'bg-neutral-1', "w-full border-2 rounded border-g h-10 p-2 outline-none flex", (opened || !!value) && !disabled
                    ? 'border-primary'
                    : 'border-neutral-3') },
                React.createElement("input", { autoComplete: "off", autoCapitalize: "off", spellCheck: "false", className: clsx('input-noSelection placeholder-neutral-4 flex w-full select-none flex-grow bg-transparent outline-none px-2', textColor, cursor), value: nativeInputValue, placeholder: placeholder, disabled: disabled, onFocus: composeHandlers([onNativeInputFocus, onFocusProp]), onBlur: composeHandlers([onNativeInputBlur, onBlurProp]), ref: nativeInputElement, readOnly: true }),
                !disabled && (React.createElement("button", { ref: arrowElement, className: "flex items-center cursor-pointer ml-2", onFocus: onForwardFocus, tabIndex: -1, type: "button" },
                    React.createElement(ChevronIconComponent, { className: clsx('w-6', textColor) }))))),
        opened && (React.createElement(DropdownList, { referenceElement: wrapperElement, onSelectOption: onSelectOption, options: options, getOptionLabel: getOptionLabel, ref: optionListElement }))));
}
